var DatePicker = $.extend({/* DatePicker */}, BaseComponent, {

	componentSelector: '.calendar',

	init: function() {
		this.loadTranslations();
		this.initDatePickers();
	},

	initDatePickers: function() {

		$(this.componentSelector).each((function (index, element) {

			$(element).datepicker('remove');

			$(element).datepicker({
				language: this.getDatepickerCodeLanguage(Language.getLanguage()),
				format: 'dd/mm/yyyy',
				autoclose: true,
				container: device.mobile() ? 'body' : '.input-with-icon-calendar',
				orientation: device.mobile() ? 'left top' : 'left auto'
			});

			if (!$(element).attr('value') == undefined || !$(element).attr('value') == '') {
				var dob = $(element).attr('value').replace('/', '-');

				$(element).datepicker('update', '');
				$(element).datepicker('update', new Date(dob));
			}
			else {
				$(element).datepicker('update', '');
			}

		}).bind(this));
	},

	loadTranslations: function () {

		$.fn.datepicker.dates['es'] = {
			days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
			daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
			daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
			months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
			monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
			today: "Hoy",
			clear: "Borrar",
			weekStart: 1,
			format: "dd/mm/yyyy"
		};

		$.fn.datepicker.dates['ca'] = {
			days: ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"],
			daysShort: ["Diu",  "Dil", "Dmt", "Dmc", "Dij", "Div", "Dis"],
			daysMin: ["dg", "dl", "dt", "dc", "dj", "dv", "ds"],
			months: ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"],
			monthsShort: ["Gen", "Feb", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Des"],
			today: "Avui",
			clear: "Esborrar",
			weekStart: 1,
			format: "dd/mm/yyyy"
		};

		$.fn.datepicker.dates['en-EN'] = {
			days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
			daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
			months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			today: "Today",
			clear: "Clear",
			weekStart: 1,
			format: "dd/mm/yyyy"
		};
	},

	getDatepickerCodeLanguage: function (lng) {
		var codes = {
			'es-ES': 'es',
			'en-EN': 'en-EN',
			'es-CA': 'ca'
		};

		return (typeof codes[lng] != 'undefined' ? codes[lng] : 'en-EN');
	}
})